(function ( $ ) {

'use strict';

	/**
	 * options could be overriden by extending the $.morejs_options in /ucont/js/custom.js
	 * Example: $.morejs_options = $.extend(true, $.morejs_options, 
	 * 								mpAccordion: {
	 *										disableAccordion: true
										},	// mpAccordion
	 *									
	 *								);
	 */
	$.morejs_options = {
		commonElementInit: {
			initImgLightbox: true,	// enable click handler for img's to show a lightbox
			customInit: null		// Custom element initialzing function
		},
		mpAccordion: {
			
		},	// mpAccordion
		searchCMS: {
			
		},	// search
		slideDown: {
			duration: 300,
			easing: 'linear'
		},	// slideDown
		messi: {
			defaultOpt: {
					padding: '15px',
					width: '380px',
					animate: {open: 'fadeInDown',  close: 'fadeOut'}
			},	// messi.defualtOpt
			confirmDlg:{
					modal: true,
					modalOpacity: .5,
					buttons: [{id: 0, label: 'OK', val: 'X'}]
			},	// messi.confirmDlg
			position:  function() { 
					var $posObj = $('#wrapper,main,#main').first();
					var pos = { top: 0, left: 0 };
					var maxWidth = $(window).width();
					var width = (maxWidth < 500 ? maxWidth : 500);
					var leftPos = 0;
					if ($posObj.length > 0) {
						pos = $posObj.offset();
						leftPos = Math.max(0, (pos.left + $posObj.width() - width));
					}
					return {center: false,
						position: {top: (pos.top+10)+'px', left: leftPos+'px'},
						width: width+'px'
						};
			}	// messi.position
		},	// messi
		sandwichMenu: {
			openedSubMenuArrow: '&#x25bc;',
			closedSubMenuArrow: '&#x25ba;',
			onOpen: null,	// function to i.e. change some styles when the menu opens
			onClose: null	// function to i.e. change some styles when the menu close
		},	// sandwichMenu
		slidersGlobal: {
			sliderAutoRun: true,	// set to false to disable slider autorun
			stopAutoOnClick: true,	// stop the auto change function if a control was clicked
		}, // slidersGlobal
		scrollToTop: {
			//contentSelector: '#wrapper, .wrapper',
			anim: {}
		},	// scrollToTop
		/**
		 * cssSwitchConfig defines css switch categories using several options
		 * to load css files.
		 * Switch options has to be defined as an array of css filenames
		 * without extension '.css'.
		 * 
		 * For every switch option of the data object an entry 
		 * '<optionname>-default' is required on any position. This is used 
		 * to remove the css and go back to the default settings.
		 * 
		 * Use any markup for the html elements and define the id's equal to 
		 * the option name i.e. <li id="zoom200" accesskey="z"...>
		 * As accesskey use 'z' for all zoom and 'i' for all inverse 
		 * options.
		 * 
		 * To implement a reset all css element use the id 'csssw-reset' .
		 * 
		 * Markup example:
		  <ul style="position: absolute; left: 0; top:0;">
			<li><a id="zoom-default" class="csssw-zoom" accesskey="z">Defaultsize</a></li>
			<li><a id="zoom200" class="csssw-zoom" accesskey="z">zoom 200%</a></li>
			<li><a id="whiteonblack" class="csssw-inverse" accesskey="i">Invers</a></li>
			<li><a id="inverse-default" class="csssw-inverse" accesskey="i">Defaultcolor</a></li>
			<li><a id="csssw-reset" >Default all</a></li>
		  </ul>
		 *
		 * 
		 * CSS has to be stored in the customer directory '/ucont/css/'
		 * i.e. /ucont/css/zoom150.css
		 * It contains the style declarations to switch the layout
		 * 
		 * Options are processed in the order they are declared.
		 * So the css files are processed in this order too.
		 * The following example 1st loads the selected 'zoom' css file 
		 * and after that the selected 'inverse' css file
		 */
		cssSwitchConfig: {
			/**
			 * define switch options
			 */
			data: {
				/**
				 * category zoom
				 */
				zoom: {
					/**
					 * add classes prev/next to the elements
					 */
					addPrevNextClasses: true,
					/**
					 * available zooming css options
					 */
					options: [
//						'zoom80',	// set font-size to 0.5em
						'zoom-default',
//						'zoom150',	// set font-size to 1.5em
						'zoom200'	// set font-size to 2em. "/css/zoom200.css" is available for the core
					],
					/**
					 * If the markup need special init a load function could be used.
					 * load() is executed after cssSwitcher is initialized.
					 * @param {string} optionName the current selected css option i.E. "zoom200"
					 * @returns {undefined}
					 */
					load: function(optionName) { 
						switch (optionName) {
							case 'zoom200':
								// create the menu button, because the menu is hidden via css. 
								// Use attribute 'data-pinned="1"' that styles.js did not remove the button
								var navBtn = $('header nav').first().find('a.nav-btn');
								if (navBtn.length < 1) {
									$('header nav').first().prepend('<a class="nav-btn" accesskey="n" href="javascript:;" data-pinned="1">menu</a>');								
								} else {
									navBtn.attr('data-pinned', '1');
								}
								break;
						}
					}
				},
				/**
				 * category inverse
				 */
				inverse: {
					//load: function(optionName) { console.log('cssSwitcher.load("' + optionName + '")'); },
					options: [
						'inverse-default',
						'whiteonblack'		// white text, black background. "/css/whiteonblack.css" is available for the core
//						'yellowongreen'
					]
				}
			},
			/**
			 * If the markup need special init after all elements are loaded,
			 * the initialize function could be used.
			 * load() is executed after cssSwitcher is initialized.
			 * @returns {undefined}
			 */
			initialized: null //function() {console.log('AccInit initalized()');}
			
		}, // cssSwitchConfig
		/**
		 * sorting indicator characters
		 */
		sortIndicators:{
			asc: '\u25b2', // up arrow to indicate ascending sort order
			desc: '\u25bc' // up arrow to indicate descending sort order
		}, // sortIndicators
		/**
		 * override editor configuration options
		 */
		editorConfig: {			
		}, // editorConfig		
		/**
		 * responsive menu
		 */
		responsiveMenuConfig: {
			breakPointWidth: 987,	// breakpoint when .nav-btn shows (responsive menu is visible)
			scrollbarWidth: 17		// scrollbar width used for calculation if window.width < document.width
		}, // responsiveMenuConfig
		keepSessionAliveConfig: {
			enabled: false
		},
		/**
		 * contentlist search
		 */
		clSearchConfig: {
			onePageScroll: false
		}, // clSearchConfig
		wsConfig: {
			minWidthDesktop: 987
		},
		/**
		 * templates used by js functions
		 */
		templates: {
			shopPreviewProduct: '<div class="articlepreview"><img /><h3></h3><p class="prodDesc"></p><a></a></div>'
		},
		/**
		 * customSlidersInit overrride some slider default options
		 * @param {array} $activeSliders
		 * @returns {undefined}
		 */
//		customSlidersInit: function($activeSliders){
//			$activeSliders.push($('.customslider').bxSlider({
//				speed: 1350,
//				slideMargin: 20,
//				adaptiveHeight: true,
//				pager: false,
//				onSlideBefore: function () {
//					$(this).closest('.bx-wrapper').find('.bx-controls-direction').hide(0);
//				},
//				onSlideAfter: function () {
//					$(this).closest('.bx-wrapper').find('.bx-controls-direction').fadeIn(150);
//				},
//			}));
//		}
		
	}; // $.morejs_options
}(jQuery));